export default __webpack_public_path__ + "static/media/Status & Control.7370153b.png";